/**
 * Cloud V2 — Comprar por Liga: carrossel automático em "esteira", com
 * navegação manual (setas em desktop, swipe em mobile).
 *
 * A lista de ligas é renderizada 3x no Liquid (ver cloud-leagues.liquid):
 * [cópia A][cópia B][cópia C]. Começamos a meio (início da cópia B), o que
 * dá margem para avançar (entrando na cópia C) OU recuar (entrando na
 * cópia A) sem nunca mostrar espaço vazio. Sempre que o índice sai da
 * cópia B, assim que a transição termina damos um salto instantâneo (sem
 * transição) de volta para a posição equivalente na cópia B — como as 3
 * cópias são idênticas, o salto é invisível e o loop fica infinito nos
 * dois sentidos.
 *
 * Comportamento idêntico em todos os breakpoints (mesmo transform/índice,
 * mesmo swipe) — só muda por CSS (.cloud-league-item, ver cloud-base.css:
 * 8 no desktop, 5 no tablet, 3 no mobile ≤480px, com setas visíveis) e o
 * autoplay, que fica desligado ≤480px (só navegação manual por seta/swipe,
 * a pedido do utilizador — ver mobileQuery em start()).
 */
(function () {
  'use strict';

  function initLeaguesCarousel(container) {
    // A Shopify dispara "shopify:section:load" também no carregamento normal
    // da loja (não só no editor de temas), o que corria este init() uma
    // segunda vez sobre o mesmo container — duas instâncias com listeners e
    // setInterval próprios no mesmo botão/track, causando cliques que ora
    // não moviam nada ora saltavam 2 posições de uma vez. Este guard torna
    // o init idempotente por container.
    if (container.dataset.leaguesCarouselInit === 'true') return;
    container.dataset.leaguesCarouselInit = 'true';

    const viewport = container.querySelector('#cloud-leagues-viewport') || container.querySelector('.cloud-leagues__viewport');
    const track = container.querySelector('#cloud-leagues-track') || container.querySelector('.cloud-leagues__track');
    const prevBtn = container.querySelector('#cloud-leagues-prev');
    const nextBtn = container.querySelector('#cloud-leagues-next');
    if (!viewport || !track) return;

    const items = Array.from(track.children);
    const originalCount = Math.round(items.length / 3);
    if (originalCount < 1) return;

    const seconds = parseFloat(viewport.getAttribute('data-autoplay-seconds')) || 4;
    let index = originalCount; // começa no início da cópia B (equivale ao item 0)
    let timer = null;
    let restartTimeout = null;
    let hovering = false;

    // ≤480px: só navegação manual (seta/swipe), sem autoplay — mesmo
    // breakpoint do CSS que mostra 3 itens + setas no mobile.
    const mobileQuery = window.matchMedia('(max-width: 480px)');

    function itemWidth() {
      return items[0].getBoundingClientRect().width;
    }

    function goTo(i, animate) {
      track.style.transition = animate ? 'transform 0.6s ease' : 'none';
      track.style.transform = 'translateX(-' + (i * itemWidth()) + 'px)';
    }

    function settle() {
      // Depois de uma transição, se saímos da cópia B (o "miolo" seguro),
      // salta sem animação de volta para a posição equivalente nela.
      if (index >= originalCount * 2) {
        index -= originalCount;
        goTo(index, false);
      } else if (index < originalCount) {
        index += originalCount;
        goTo(index, false);
      }
    }

    function next() {
      index += 1;
      goTo(index, true);
      setTimeout(settle, 620);
    }

    function prev() {
      index -= 1;
      goTo(index, true);
      setTimeout(settle, 620);
    }

    function start() {
      stop();
      if (hovering || mobileQuery.matches) return;
      timer = setInterval(next, seconds * 1000);
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    // Navegação manual (seta ou swipe): pausa o autoplay e reinicia o
    // temporizador a partir desse momento, para não competir com o clique.
    function manualNav(action) {
      stop();
      clearTimeout(restartTimeout);
      action();
      restartTimeout = setTimeout(start, seconds * 1000);
    }

    if (nextBtn) nextBtn.addEventListener('click', () => manualNav(next));
    if (prevBtn) prevBtn.addEventListener('click', () => manualNav(prev));

    viewport.addEventListener('mouseenter', () => { hovering = true; stop(); });
    viewport.addEventListener('mouseleave', () => { hovering = false; start(); });

    // Swipe em touch: gesto discreto (arrasta e larga), sem seguir o dedo
    // 1:1 — ao soltar, encaixa no item anterior/seguinte ("snap").
    let touchStartX = null;
    viewport.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      stop();
      clearTimeout(restartTimeout);
    }, { passive: true });

    viewport.addEventListener('touchend', (e) => {
      if (touchStartX === null) return;
      const deltaX = e.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      const threshold = 40;
      if (deltaX <= -threshold) {
        next();
      } else if (deltaX >= threshold) {
        prev();
      }
      restartTimeout = setTimeout(start, seconds * 1000 + 1500);
    }, { passive: true });

    window.addEventListener('resize', () => goTo(index, false));

    goTo(index, false);
    start();
  }

  function init() {
    document.querySelectorAll('.cloud-leagues__carousel').forEach(initLeaguesCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const container = e.target.querySelector('.cloud-leagues__carousel');
    if (container) initLeaguesCarousel(container);
  });
})();
